<div class="p-6">
  @if (loading) {
    <div class="flex justify-center py-12"><div class="animate-spin rounded-full h-7 w-7 border-b-2 border-brand-500"></div></div>
  }

  @if (error) {
    <div class="mb-4 p-3 rounded-lg bg-error-50 border border-error-200 text-sm text-error-700 dark:bg-error-500/10 dark:border-error-500/20 dark:text-error-400">
      {{ error }}
    </div>
  }

  @if (!loading) {
    <form [formGroup]="form" (ngSubmit)="guardar()" class="space-y-6">

      <section class="space-y-4">
        <h3 class="text-xs font-semibold uppercase text-gray-500 tracking-wider">Datos básicos</h3>

        <div>
          <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
            Motivo <span class="text-error-500">*</span>
          </label>
          <input type="text" formControlName="name" placeholder="Ej. Cliente no contestó"
            class="dark:bg-dark-900 h-11 w-full rounded-lg border bg-transparent px-4 py-2.5 text-sm dark:border-gray-700 dark:bg-gray-900 dark:text-white/90"
            [class.border-error-500]="hasError('name')" [class.border-gray-300]="!hasError('name')"/>
          <p class="mt-1 text-xs text-gray-500">Aparece como opción al cancelar tareas (lifecycle/bulk).</p>
          @if (hasError('name')) { <p class="mt-1.5 text-sm text-error-500">{{ getError('name') }}</p> }
        </div>

      </section>

      <section>
        <label class="flex items-start gap-3 p-3 rounded-lg bg-gray-50 dark:bg-gray-800/40 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-800/60 transition-colors">
          <div class="relative inline-flex shrink-0 mt-0.5">
            <input type="checkbox" formControlName="isActive" class="peer sr-only"/>
            <div class="w-11 h-6 bg-gray-300 dark:bg-gray-700 rounded-full peer-checked:bg-brand-500 transition-colors"></div>
            <div class="absolute left-0.5 top-0.5 w-5 h-5 bg-white rounded-full shadow transition-transform peer-checked:translate-x-5"></div>
          </div>
          <div class="flex-1">
            <span class="block text-sm font-medium text-gray-800 dark:text-gray-100">Motivo activo</span>
            <span class="block text-xs text-gray-500">Si se desactiva, no aparecerá al cancelar tareas. Las tareas que ya lo usaban conservan su referencia histórica.</span>
          </div>
        </label>
      </section>

      <div class="flex items-center justify-end gap-3 pt-4 border-t border-gray-200 dark:border-gray-700">
        <app-button variant="outline" type="button" (btnClick)="cancelar()">Cancelar</app-button>
        <app-button variant="primary" type="submit" [disabled]="saving || form.invalid">
          {{ saving ? 'Guardando...' : (isEditing ? 'Actualizar' : 'Crear') }}
        </app-button>
      </div>
    </form>
  }
</div>
